import { theme } from '@prophecy/theme';
import { Stack } from '@prophecy/ui-v3';
import React from 'react';
import styled from 'styled-components';

import { DatasetEntityType, TranspilerEntityType } from '../../../../../data/apis/transpileTypes';
import { RecommendedPsets } from '../../components/RecommendedPsets';
import { useImportState } from '../../useImportState';
import { EntityDatasets } from './EntityDatasets';
import { EntityJobs } from './EntityJobs';
import { EntityPipelines } from './EntityPipelines';

const StyledStack = styled(Stack)`
  overflow: auto;
`;
export const EntityForm = ({
  data,
  handleDatasetConfig,
  disableConfigButton
}: {
  data: TranspilerEntityType;
  handleDatasetConfig: (dataset: DatasetEntityType) => void;
  disableConfigButton?: boolean;
}) => {
  const {
    formDataWithActions: { recommendedPsetPath }
  } = useImportState();
  const { datasets = [], pipelines, jobs } = data;
  return (
    <StyledStack height='100%' width='100%' gap={theme.spaces.x32} padding={theme.spaces.x6}>
      <EntityJobs jobs={jobs} hasPipelines={pipelines.length > 0} />
      <EntityPipelines pipelines={pipelines} hasJobs={jobs.length > 0} />
      {datasets.length > 0 && (
        <EntityDatasets
          datasets={datasets}
          hasPipelines={pipelines.length > 0}
          handleDatasetConfig={handleDatasetConfig}
          disableConfigButton={disableConfigButton}
        />
      )}
      {recommendedPsetPath && <RecommendedPsets />}
    </StyledStack>
  );
};
